import { render, staticRenderFns } from "./platAccount.vue?vue&type=template&id=08602226&scoped=true&"
import script from "./platAccount.vue?vue&type=script&lang=js&"
export * from "./platAccount.vue?vue&type=script&lang=js&"
import style0 from "./platAccount.vue?vue&type=style&index=0&id=08602226&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08602226",
  null
  
)

export default component.exports